var render = function render(){var _vm=this,_c=_vm._self._c;return _c('publisher-dashboard-section-wrapper',{attrs:{"title":"Developers Map"}},[_c('div',{ref:"map",attrs:{"id":"svgMap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }